import React from 'react';
import {
  Box,
  Input,
  Flex,
  FormControl,
  FormErrorMessage,
  Heading,
  Textarea,
  Button,
  FormLabel,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { Email } from '@zap-onboard/api-client';
import { track } from '../../../libs/track';
import { auth } from '../../../auth';

type FormInputs = {
  name: string;
  email: string;
  message: string;
};

export const SupportForm: React.FC = () => {
  const { handleSubmit, errors, register } = useForm<FormInputs>();
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [isFormSubmitted, setIsFormSubmitted] = React.useState<boolean>(false);
  track.useOnMount('Viewed Support');
  const onSubmit: SubmitHandler<FormInputs> = (formData) => {
    setIsSubmitting(true);
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => data.append(key, value));

    fetch('https://getform.io/f/7b2a8b24-87da-4ae5-b3aa-dc9b1b84b059', {
      method: 'POST',
      body: data,
    }).then(() => {
      toast({
        title: 'Success!',
        description: 'Your request has been submitted',
        status: 'success',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
      setIsSubmitting(false);
      setIsFormSubmitted(true);
    });
  };

  const userProfile = auth.useProfile();

  return (
    <Box p="4" layerStyle="base">
      <Heading variant="section" textAlign="center">
        Contact us
      </Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl id="name" isInvalid={!!errors.name}>
          <FormLabel my={3}>Name</FormLabel>
          <Input
            name="name"
            placeholder="Your name"
            defaultValue={userProfile?.getUserName() ?? ''}
            ref={register({ required: 'Name required' })}
          />
          <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
        </FormControl>
        <FormControl id="email" isInvalid={!!errors.email}>
          <FormLabel my={3}>Email</FormLabel>
          <Input
            name="email"
            placeholder="Your email"
            defaultValue={userProfile?.email?.asJSON() ?? ''}
            ref={register({
              required: 'Email required',
              validate: Email.validationMessage,
            })}
          />
          <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
        </FormControl>
        <FormControl id="message" isInvalid={!!errors.message}>
          <FormLabel my={3}>Message</FormLabel>
          <Textarea
            name="message"
            placeholder="Your message"
            rows={8}
            h="auto"
            ref={register({
              required: 'Message required',
            })}
          />
          <FormErrorMessage>{errors.message?.message}</FormErrorMessage>
        </FormControl>
        {/* eslint-disable-next-line no-nested-ternary */}
        {isSubmitting ? (
          <Spinner size="sm" />
        ) : isFormSubmitted ? (
          <Heading variant="section">Your request has been submitted</Heading>
        ) : (
          <Flex mt="4" justify="center" align="center">
            <Button type="submit">Submit</Button>
          </Flex>
        )}
      </form>
    </Box>
  );
};
